<template>
  <v-dialog v-model="dialog" max-width="500px">
    <template v-slot:activator="{on, attrs}">
      <v-btn color="white" dark class="mb-2 red--text" rounded v-bind="attrs" v-on="on">Add new</v-btn>
    </template>
    <v-card>
      <v-toolbar color="secondary" class="mb-5">
        <v-toolbar-title>New File</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            label="File Name"
            v-model="filename"
            :rules="fileNameRules"
            prepend-icon="mdi-image"
            required
            outlined
            dense
            rounded
          />

          <v-file-input
            type="file"
            outlined
            rounded
            dense
            @change="fileSelected"
            accept=".pdf,image/*"
            required
            label="File image (Images), PDF Documents"
            :rules="fileRules"
            v-model="theFile"
            filled
            placeholder="Click to select an image"
            prepend-icon="mdi-camera"
          ></v-file-input>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary darken-1" rounded @click="save">Save</v-btn>
        <v-btn color="secondary darken-1" text @click="close">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    valid: true,
    fileNameRules: [v => !!v || "File name is required"],
    fileRules: [v => !!v || "File is required"],
    theFile: null,
    filename: "",
    newFile: ""
  }),
  methods: {
    fileSelected() {
      let formData = new FormData();
      formData.append("file", this.theFile);
      formData.append("filename", this.filename);
      //formData.append("id", this.orgId);
      this.newFile = formData;
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    save() {
      if (this.$refs.form.validate()) {
        
        //this.$store.dispatch("organisation/aUploadFile", this.newFile);
        this.$store.dispatch("files/aAdd", this.newFile).then(res => {
          this.filename = ""
          this.theFile = null
          if (res) {
            this.dialog = false;
          }
        });
        
      }
    }
  }
};
</script>

<style>
</style>